import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './company-verification-request.component.less'],
  templateUrl: './company-verification-request.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class CompanyVerificationRequestTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<CompanyVerificationRequestTemplateData>;
}

export type CompanyVerificationRequestTemplateData = {
  title: string;
  p1: string;
  button_text: string;
  button_link: string;
  footer_link_text: string;
  support_email: string;
};

export const CompanyVerificationRequestTemplateMocks: CompanyVerificationRequestTemplateData[] = [
  {
    title: 'Company successfully verified',
    p1: 'Thank you for veryfing your company account. Enjoy full access to all Recruitee features.',
    button_text: 'Go to Recruitee',
    button_link: 'http://recruitee.com',
    footer_link_text: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
